const initialState = {
  analytics: {}
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'analytics':
      return {
        ...state,
        analytics: action.payload
      };

    default:
      return state;
  }
};

export default dashboardReducer;
